import React from 'react';
import { Icon } from './Icon.js';
export const IconLessThanFill18 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "18px", ...props },
        React.createElement("path", { d: "m14.249,16c-.1299,0-.2627-.0342-.3828-.1055L3.3662,9.6445c-.2266-.1353-.3662-.3804-.3662-.6445s.1396-.5093.3662-.6445L13.8662,2.1055c.3564-.2114.8164-.0938,1.0283.2607.2119.356.0947.8164-.2607,1.0283l-9.417,5.6055,9.417,5.6055c.3555.2119.4727.6724.2607,1.0283-.1406.2354-.3896.3662-.6455.3662Z", strokeWidth: "0", fill: "currentColor" })));
};
//# sourceMappingURL=IconLessThanFill18.js.map